import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-user-button',
	templateUrl: './user-button.component.html',
	styleUrls: ['./user-button.component.scss']
})
export class UserButtonComponent implements OnInit {
	@Input() userbasics: any
	@Input() userid: string
	@Input() path: any
	@Input() type: string

	@Output() removeEvent = new EventEmitter();

	displayName: string
	photo: any
	folder: any

	constructor(
	) {}

	ngOnInit() {
		this.init()
	}

	ngOnChanges(changes: SimpleChanges) {
		this.init()
	}

	init() {
		if (!this.userbasics) return
		this.displayName = this.userbasics.name
		let path = [].concat(this.path).reverse()
		this.folder = path.length >= this.userbasics.level ? path[this.userbasics.level - 2] : null
	}

	onRemove() {
		this.removeEvent.emit({uid: this.userid, type: this.type})
	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/user-button/user-button.component.ts